import { useEffect, useState } from "react";
import { useLocalStorage } from "../utils/LocalStorageHook";
import { BASE_URL } from "../App";
import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Select,
  CircularProgress,
  Grid,
  MenuItem,
  Switch,
  Tooltip,
  FormControlLabel,
  Slider,
} from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { GetLocalFavorite, localFavorite } from "../utils/GetCustomer"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    downTrend: {
      color: theme.palette.statusRed.main,
    },
    fullHeight: {},
    upTrend: {
      color: theme.palette.statusGreen.main,
    },
    cellChanged: {
      fontWeight: "bolder",
      backgroundColor: theme.palette.highlightRow.main,
    },
    centerDiv: {
      textAlign: "center",
    },
    cell: {},
    modalInput: {
      width:"150px"
    },
    lfCellDefault: {
    },
    lfCellInNew: {
      backgroundColor:theme.palette.highlightRow.main
    },
    lfCellInCur: {
      backgroundColor:theme.palette.dhighlightRow.main
    },
    lfCellDisabled: {
      backgroundColor:theme.palette.action.disabledBackground
    },
    
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    cards:{
      height: "100%",
      border:"none",
      boxShadow: "none"
    },
    gridMarginTop: {
    },
  })
);

interface sortMthd{
  category:'all'|'fsv'|'con';
  metric:'acv'|'percent_volume'|'min_percent_volume'|'max_percent_volume';
  aml_only:boolean;
  fits_only:boolean,
  pack_filter:'all'|'BT'|'CN'
}
const CATEGORY:{code:string,text:string}[] =[
  {code:'all',text:'Both'},
  {code:'fsv',text:'FSV Only'},
  {code:'con',text:'Convenience'},
]
  const METRIC:{code:string,text:string}[] =[
  {code:'acv',text:'ACV %'},
  {code:'percent_volume',text:'Volume %'},
  {code:'min_percent_volume',text:'Min Volume %'},
  {code:'max_percent_volume',text:'Max Volume %'},
]
const PACK_FILTER:{code:string,text:string}[] =[
  {code:'all',text:'Any'},
  {code:'BT',text:'Bottle Only'},
  {code:'CN',text:'Cans Only'},
]

/**
 * Generates a react card that handles building and displaying local favorites when given a customer number
 * @param props.customerNum The customer that we are using
 * @param props.lfRows how many rows to display in result table
 * @param props.lfCols how many columns to display in result table
 * @param props.curMaterialNums OPTIONAL - list of current materialNum in the machine. Used for formatting 
 * @param props.newMaterialNums OPTIONAL - 
 * @returns 
 */
export default function CardLocalFavorites(props: { customerNum: string, lfRows?: number, lfCols?: number, curMaterialNums?: string[], newMaterialNums?: string[] }) {
  const classes = useStyles();

  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [sortMethod, setSortMethod] = useState<sortMthd>({category:'con',metric:'percent_volume',aml_only:true,fits_only:false,pack_filter:'all'});
  const [localFavorites, setLocalFavorites] = useState<localFavorite[]|undefined>(undefined);
  const [mileRange, setMileRange] = useState<number>(5.0);
  const [daysBack, setDaysBack] = useState<number>(7);

  const customerNum = props.customerNum;
  const curMaterialNums = props.curMaterialNums || []
  const newMaterialNums = props.newMaterialNums || []
  const lfRows = props.lfRows || 3
  const lfCols = props.lfCols || 8

  useEffect(() => {
    if(!localFavorites){
      GetLocalFavorite(salesOrg,customerNum,mileRange,daysBack).then(favorites => {
        setLocalFavorites(favorites)
      })
    }

  }, [localFavorites,mileRange,daysBack,sortMethod]);

  const getDisplayFavorites = (row:number,col:number) =>{
    const cat = sortMethod.category;
    const met = sortMethod.metric;
    const srt = (a:localFavorite,b:localFavorite) =>{
      let aObj = a[cat], bObj = b[cat]
      let aVal = aObj?aObj[met]:0
      let bVal = bObj?bObj[met]:0
      return bVal - aVal
    }
    let lfs = (localFavorites||[])
              .filter(lf=>!sortMethod.aml_only || lf.on_aml)
              .filter(lf=>!sortMethod.fits_only || lf.fits_in_machine)
              .filter(lf=>sortMethod.pack_filter==='all' || lf.pack_filter === sortMethod.pack_filter)
              .sort(srt)

    let ret:localFavorite[][] = []
    for(let r=0; r<row; r++){
      ret.push(lfs.slice(r*col,(r+1)*col))
    }
    return ret
  }
  const formatPercentage = (num:number) => {
    return `${(Math.round(num * 100) / 100).toFixed(2)}%`
  }
  const getFormating = (lf:localFavorite) =>{
    const inCur = curMaterialNums.findIndex(mat=>mat===lf.material_num) >= 0
    const inNew = newMaterialNums.findIndex(mat=>mat===lf.material_num) >= 0
    const onAml = lf.on_aml

    let cellStyle = classes.lfCellDefault;
    if(inNew){
      cellStyle = classes.lfCellInCur;
    } else if(inCur){
      cellStyle = classes.lfCellInNew;
    } else if(!onAml){
      cellStyle = classes.lfCellDisabled;
    }


    return {
      cellStyle,
      inCur,
      inNew,
      onAml,
    }

  }
  return (
    <Card className={classes.cards}>
      <CardContent className={classes.fullHeight}>
        <Typography variant="h4" className={classes.centerTitle}>
          Local Favorites
        </Typography>
        <Grid container spacing={2} className={classes.gridMarginTop}>
        <Grid
              item
              xs={12}
              md={6}
              lg={6}
              className={classes.gridSpaceable}
            >
            <div style ={{paddingLeft:'20px',paddingRight:'20px'}}> 
              <Slider 
                disabled={!localFavorites}
                defaultValue={mileRange}
                value={mileRange}
                onChange={(ce,val)=>{ 
                  if (typeof val === "number") 
                    setMileRange(val)
                  else 
                    setMileRange(val[0])
                }}
                onChangeCommitted={(ce,val)=>{setLocalFavorites(undefined)}}
                aria-label="Default" 
                valueLabelDisplay="auto" 
                step={0.5} 
                min={0.5} 
                max={30} 
                marks={[
                  {value: 5,label: '5 Miles',},
                  {value: 10,label: '10 Miles',},
                  {value: 20,label: '20 Miles',},
                  {value: 30,label: '30 Miles',},
                ]}
                />
            </div>
          </Grid>
          <Grid
              item
              xs={12}
              md={6}
              lg={6}
              className={classes.gridSpaceable}
            >
            <div style ={{paddingLeft:'20px',paddingRight:'20px'}}> 
              <Slider 
                disabled={!localFavorites}
                defaultValue={daysBack/7}
                value={daysBack/7}
                onChange={(ce,val)=>{ 
                  if (typeof val === "number") 
                    setDaysBack(val*7)
                  else 
                  setDaysBack(val[0]*7)
                }}
                onChangeCommitted={(ce,val)=>{setLocalFavorites(undefined)}}
                aria-label="Default" 
                valueLabelDisplay="auto" 
                step={1} 
                min={1} 
                max={9} 
                marks={[
                  {value: 2,label: '2 Weeks',},
                  {value: 4,label: '4 Weeks',},
                  {value: 8,label: '8 Weeks',},
                ]}
                />
            </div>
          </Grid>
          <Grid item xs={2} md={2} lg={2} className={classes.gridSpaceable}>
            <Tooltip title="Filters for type of customer to look at sales volumes">
              <div>Customer Type</div>
            </Tooltip>
            <Select label="Customer Type" value={sortMethod.category}
              className={classes.modalInput}
              onChange={(e) => {
                let val:'all'|'fsv'|'con' = 'all'
                if(e.target.value &&  typeof e.target.value == 'string'){
                  if(e.target.value === 'fsv') val='fsv'
                  if(e.target.value === 'con') val='con'
                }
                setSortMethod(
                  { 
                    ...sortMethod,
                    category:val,
                  }); 
              }}>
                {(CATEGORY)?(Object.entries(CATEGORY).map((so: any, i: number) => (
                  <MenuItem key={so[1].code} value={so[1].code}>
                    {so[1].text}
                  </MenuItem>
                  ))):(<div></div>)}
            </Select>
          </Grid>
          <Grid item xs={2} md={2} lg={2} className={classes.gridSpaceable}>
            <Tooltip title="Metric to consider">
              <div>Metric</div>
            </Tooltip>
            <Select label="Metric" value={sortMethod.metric}
              className={classes.modalInput}
              onChange={(e) => {
                let val:'acv'|'percent_volume'|'min_percent_volume'|'max_percent_volume' = 'percent_volume'
                if(e.target.value &&  typeof e.target.value == 'string'){
                  if(e.target.value === 'percent_volume') val='percent_volume'
                  if(e.target.value === 'acv') val='acv'
                  if(e.target.value === 'min_percent_volume') val='min_percent_volume'
                  if(e.target.value === 'max_percent_volume') val='max_percent_volume'
                }
                setSortMethod(
                  { 
                    ...sortMethod,
                    metric:val,
                  }); 
              }}>
                {(METRIC)?(Object.entries(METRIC).map((so: any, i: number) => (
                  <MenuItem key={so[1].code} value={so[1].code}>
                    {so[1].text}
                  </MenuItem>
                  ))):(<div></div>)}
            </Select>
          </Grid>
          <Grid item xs={2} md={2} lg={2} className={classes.gridSpaceable}>
            <Tooltip title="Only display products on the current AML">
              <FormControlLabel 
                label="On AML"
                control={
                  <Switch 
                    checked={sortMethod.aml_only}
                    onClick={() => {setSortMethod({...sortMethod,aml_only:!sortMethod.aml_only})}}
                />
                }
              />
            </Tooltip>
          </Grid>
          <Grid item xs={2} md={2} lg={2} className={classes.gridSpaceable}>
            <Tooltip title="Only display products with configured capacities for the model ">
              <FormControlLabel 
                label="Fits in model"
                control={
                  <Switch 
                    checked={sortMethod.fits_only}
                    onClick={() => {setSortMethod({...sortMethod,fits_only:!sortMethod.fits_only})}}
                />
                }
              />
            </Tooltip>
          </Grid>
          <Grid item xs={2} md={2} lg={2} className={classes.gridSpaceable}>
            <Tooltip title="Filter for pack type">
              <div>Pack Filter</div>
            </Tooltip>
            <Select label="Metric" value={sortMethod.pack_filter}
              className={classes.modalInput}
              onChange={(e) => {
                let val:'all'|'BT'|'CN' = 'all'
                if(e.target.value &&  typeof e.target.value == 'string'){
                  if(e.target.value === 'BT') val='BT'
                  if(e.target.value === 'CN') val='CN'
                }
                setSortMethod(
                  { 
                    ...sortMethod,
                    pack_filter:val,
                  }); 
              }}>
                {(PACK_FILTER)?(Object.entries(PACK_FILTER).map((so: any, i: number) => (
                  <MenuItem key={so[1].code} value={so[1].code}>
                    {so[1].text}
                  </MenuItem>
                  ))):(<div></div>)}
            </Select>
          </Grid>
        </Grid>
        <br/>
        {(localFavorites)?(
          <Table>
            <TableBody>
              {getDisplayFavorites(lfRows,lfCols).map((lfRow,rIdx)=>{
                return (
                  <TableRow key={`lf-tr-${rIdx}`}>
                    {lfRow.map((lf,cIdx)=>{
                      const formating = getFormating(lf);
                      return (
                        <TableCell align="center" className={formating.cellStyle}  key={`lf-tc-${rIdx}-${cIdx}`}>
                          <Typography variant="body2">{lf.description} - {lf.material_num_short}</Typography>
                          <Table>
                            <TableBody>
                              <TableRow key={`lf-tr-dtl-${rIdx}-${cIdx}`}>
                                <TableCell  align="right" style={{borderStyle:"none"}}>
                                  <Typography variant="body2">Customers: {lf[sortMethod.category]?.cust_count || 0}</Typography>
                                  <Typography variant="body2">Volume: {formatPercentage(lf[sortMethod.category]?.percent_volume || 0)}</Typography>
                                  <Typography variant="body2">ACV: {formatPercentage(lf[sortMethod.category]?.acv || 0)}</Typography>
                                </TableCell>
                                <TableCell align="center" valign="middle" style={{borderStyle:"none"}}>
                                    <img 
                                      alt={lf.material_num}
                                      style={{
                                        position: "relative",
                                        maxWidth: 45,
                                        maxHeight: 80,
                                        margin: "0 auto",
                                        zIndex: 9,
                                      }}
                                    src={`${BASE_URL}/api/images?clientId=${clientId}&materialnumber=${lf.material_num}&salesOrg=${salesOrg}`} />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        ):(<div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>)}
      </CardContent>
    </Card>
  );
}
